import { useMemo, useState } from 'react';
import type { SearchValues } from '@/components/custom/erp/data-table-v2';
import { useAuth } from '@/contexts/auth-context';
import { toast } from '@/hooks/use-toast';

export const useHoaDonBanDichVuExport = () => {
  const [isExporting, setIsExporting] = useState(false);
  const { entity } = useAuth();

  const exportToExcel = async () => {
    if (!entity?.slug) {
      toast({
        description: 'Không tìm thấy thông tin đơn vị.',
        variant: 'default'
      });
      return;
    }

    setIsExporting(true);
    try {
      const { exportHoaDonBanDichVuFromApi } = await import('../utils/excel-export');
      await exportHoaDonBanDichVuFromApi({ entitySlug: entity.slug });
    } catch (error) {
      toast({
        description: 'Không thể kết xuất dữ liệu.',
        variant: 'destructive'
      });
    } finally {
      setIsExporting(false);
    }
  };

  return {
    exportToExcel,
    canExport: Boolean(entity?.slug),
    isExporting
  };
};
